module.exports = __webpack_public_path__ + "img/emerald.cf3a2882.webp";